<template>
    <div class="info">
        <p class="info__content">{{ content }}</p>
        <div class="info-bottom" v-if="description || button">
            <p class="info-description" v-if="button">{{ description }}</p>
            <div class="button" v-if="button">
                <p>{{ button.text }}</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Info',
    props: {
        content: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: false
        },
        button: {
            type: Object,
            required: false
        }
    }
}
</script>
<style lang="stylus">
.info
    width 100%
    padding 15px 20px
    border-radius 25px
    background-color var(--blocks)
    box-shadow var(--blocks-shadow)
    border 1px solid #eaeaea
    
    &__content
        font-size 18px
        font-weight 700
        line-height 28px
        color var(--text-main)
    
    &-bottom
        display flex
        align-items center
        justify-content space-between
        margin-top 5px
    
    &-description
        color #53cbb5
        font-size 12px
        font-weight 600
        margin-right 10px
        .button
            padding 8px 15px
</style>